











import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import TipoTramite from "@/models/tipoTramite";
import NameValue from "@/models/nameValue.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import GenericEdit from "@/core/Generics/GenericEdit";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiarioDocumento from "@/models/tramite/tramiteBeneficiarioDocumento.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import { RowTable } from "@/typings/BRowTable";

@Component({})
export default class TramiteBeneficiarioReviewComponent extends BaseVue {
  get tramiteBeneficiarioId() {
    let id = this.$route.params.id;
    return id;
  }
}
